import { css } from "styled-components";
import { Icon } from "../../../../../Icon";
export const carouselNextPrev2XKO = (chroma, paletteTokens) => css `
  height: 22px;
  width: 54px;
  line-height: 0;
  text-align: center;

  ${Icon} {
    display: none;
  }

  &::before {
    display: block;
    content: "";
    background: ${paletteTokens.accents1};
    width: 100%;
    height: 100%;
    transition:
      clip-path 0.3s ease,
      background 0.5s,
      opacity 0.5s;
    clip-path: var(--default-clip-path);

    @media (prefers-reduced-motion) {
      transition-property: none;
    }
  }

  &:hover::before,
  &:active::before {
    clip-path: var(--hover-clip-path);
    background: ${paletteTokens.accents1_hover};
  }

  &:disabled::before,
  &:disabled:hover::before {
    clip-path: var(--default-clip-path);
    opacity: 0.7;
    background: ${paletteTokens.accents1_disabled};
  }
`;
export const riotLionSkin = (chroma, paletteTokens) => css `
  --default-clip-path: path(
    "M30 22 L35 11 L30 0 L0 0 L5 11 L0 22 L30 22 L36 22 L41 11 L36 0 L49 0 L54 11 L49 22 L36 22Z"
  );
  --hover-clip-path: path(
    "M36 22 L41 11 L36 0 L0 0 L5 11 L0 22 L30 22 L36 22 L41 11 L36 0 L49 0 L54 11 L49 22 L36 22Z"
  );

  ${carouselNextPrev2XKO(chroma, paletteTokens)}
`;
//# sourceMappingURL=index.js.map